import {Box, Flex} from '@chakra-ui/react';
import {HeaderWrapper} from 'components/layouts';
import {colors} from 'components/providers';
import {FilterButtonCount} from 'components/shared';
import {sortingList} from 'config';
import {IFilterType, useDesktop, useTranslation, useWindowScroll} from 'hooks';
import {useRouter} from 'next/router';
import {FC, PropsWithChildren} from 'react';
import {ICategoryByProviderResponse, ProviderTypeEnum} from 'types';

import {OrderingModal, SortItems} from './components';

interface Props {
  categories?: ICategoryByProviderResponse[];
  showFilters?: boolean;
  displayScrollPosition?: number;
  providerType: ProviderTypeEnum;
  activeQueryParams?: IFilterType;
  onChangeActiveFiltersList: (filters: IFilterType) => void;
}

export const SubheaderWithFilters: FC<PropsWithChildren<Props>> = ({
  children,
  showFilters = true,
  displayScrollPosition,
  activeQueryParams,
  onChangeActiveFiltersList,
}) => {
  const {y: scrollY} = useWindowScroll();
  const isDesktop = useDesktop();
  const {t} = useTranslation();
  const {query} = useRouter();

  if (displayScrollPosition && scrollY < displayScrollPosition) {
    return null;
  }

  const onHandleChangeOrdering = (filters: IFilterType) => {
    onChangeActiveFiltersList({
      ...activeQueryParams,
      categorySlug: activeQueryParams?.categorySlug,
      ordering: filters.ordering,
    });
  };

  return (
    <Box position="absolute" w="100%" borderTop="1px" borderColor={colors.borderGray}>
      <HeaderWrapper boxShadow="header">
        <Flex mr="auto" h="100%" as="nav" alignItems="center" w="full">
          <Flex w="full">
            {showFilters && (
              <Box ml={['0', '10px']}>
                {isDesktop ? (
                  <SortItems
                    t={t}
                    activeQueryParams={activeQueryParams}
                    onChange={onHandleChangeOrdering}
                    sortingTypes={sortingList}
                  />
                ) : (
                  <OrderingModal
                    title={t('SORT_BY')}
                    t={t}
                    typeList={sortingList}
                    activeQueryParams={activeQueryParams}
                    onChange={onHandleChangeOrdering}
                  >
                    <FilterButtonCount filtersNumber={query?.ordering ? 1 : 0} icon="/icons/sorts.svg">
                      {t('SORT_BY')}
                    </FilterButtonCount>
                  </OrderingModal>
                )}
              </Box>
            )}
          </Flex>
        </Flex>
      </HeaderWrapper>
      {children}
    </Box>
  );
};
